
let Api = {
    //订单
	"SZGX_W_ORDER_FINDPAGELIST": "/b2b/w/order/findPageList", //分页查询订单列表
	"SZGX_W_ORDER_FINDSHOPORDERINFO": "/b2b/w/order/findShopOrderInfo", //查询店铺订商单详细信息
	"SZGX_W_ORDER_EXPORTORDER": "/b2b/w/order/exportOrder", //导出订单列表
	"SZGX_W_ORDER_CANCEL": "/b2b/w/order/cancel", //商家取消订单
	"SZGX_W_ORDER_CONFIRMORDER": "/b2b/w/order/confirmOrder", //商家确认订单
	"SZGX_W_ORDER_ORDERDELIVE": "/b2b/w/order/orderDelive", //订单发货或订单备货
	"SZGX_W_ORDER_TRACKING": "/b2b/w/order/tracking", //物流跟踪
	"SZGX_W_ORDER_TRACKINGBYORDERID": "/b2b/w/order/trackingByOrderId", //物流跟踪根据订单id
	"SZGX_W_ORDER_UPDATEQUOTED": "/b2b/w/order/updateQuoted", //商家修改报价
	"SZGX_W_ORDER_UPDATEQUOTEDCOMPUTE": "/b2b/w/order/updateQuotedCompute", //修改报价计算
    "SZGX_W_SYSTEMTAG_FINDLISTBYTYPE": "/b2b/w/systemTag/findListByType", //取消订单原因列表
    "SZGX_W_SYSTEMTAG_DELORDERDELIVERYRECORDS": "/b2b/w/order/delOrderDeliveryRecords", //删除订单发货记录-id
    "SZGX_W_SYSTEMTAG_FINDORDERDELIVERYRECORDINFO": "/b2b/w/order/findOrderDeliveryRecordInfo", //订单发货记录->参数发货记录id
    "SZGX_W_SYSTEMTAG_ORDERDELIVEINSPECT": "/b2b/w/order/orderDeliveInspect", //订单交付验收
    "SZGX_W_SYSTEMTAG_ORDERDELIVEUPDATE": "/b2b/w/order/orderDeliveUpdate", //订单发货编辑

    //退单
	"SZGX_W_ORDERREFUNDAPPL_FINDSHOPPAGELIST": "/b2b/w/OrderRefundAppl/findShopPageList", //分页查退款申请列表
	"SZGX_W_ORDERREFUNDAPPL_EXPORTORDERREFUNDAPPL": "/b2b/w/OrderRefundAppl/exportOrderRefundAppl", //导出退款订单列表
	"SZGX_W_ORDERREFUNDAPPL_FINDRIEINFO": "/b2b/w/OrderRefundAppl/findrieInfo", //查询退款详细信息
	"SZGX_W_ORDERREFUNDAPPL_ORDERREFUNDAPPLREISSUE": "/b2b/w/OrderRefundAppl/orderRefundApplReissue", //订单补发
	"SZGX_W_ORDERREFUNDAPPL_REFUNDAPPLHANDLE": "/b2b/w/OrderRefundAppl/refundApplHandle", //卖家售后处理处理
	
    "SZGX_SELLERLOGISTICSMAGE_LIST": "/b2b/w/SellerLogisticsMage/list", //获取商家物流列表
    "SZGX_W_SHOPINFO_FINDSHOPLIST": "/b2b/w/shopInfo/findShopList", //查询店铺列表
    "SZGX_W_PERSON_LIST": "/b2b/w/person/list", //查询采购商列表
    "SZGX_MEMB_AUTHENTICATIONBUYERLIST": "/system/w/memb/buyerList", //查询采购商认证列表

	"SYSTEM_W_TABLE_FINDMODEL": "/system/w/tableTrConfig/findByModel", //查询当前列表配置
	"SYSTEM_W_TABLE_SAVE": "/system/w/tableTrConfig/saveOrUpdate", //保存当前列表配置
	
}
module.exports = Api